export default "__VITE_ASSET__DDf7OcgS__"